import { useEffect, useState } from "react";
import { X } from "react-feather";
import styles from "./movein-checklist.module.css";
import { Button } from "@mui/material";
import ArrivalForm from "./components/arrival-form/ArrivalForm";
import FormHeader from "./components/FormHeader";
import FormFooter from "./components/FormFotter";
import FormComments from "./components/Comments";
import { toast } from "react-smart-toaster";
import axios from "axios";
import { useAuth0 } from "@auth0/auth0-react";
import Loader from "../../../components/Loader";
import MoveInChecklistPDF from "./components/MoveInChecklistPDF";

const MoveInChecklist = ({ setMoveInChecklistOpen, moveInChecklistOpen, tenantId, isFormSubmitted, onSubmitted }) => {
  const [loading, setLoading] = useState(false);
  const { getAccessTokenSilently } = useAuth0();
  const [moveInCheckListInfo, setMoveInCheckListInfo] = useState(null);
  const [signatureCommentsData, setSignatureCommentsData] = useState({});
  const [moveInChecklistPDFContent, setMoveInChecklistPDFContent] = useState();

  useEffect(() => {
    if (tenantId && !isFormSubmitted) {
      getMoveInCheckListInfo();
    }
    if (tenantId && isFormSubmitted) {
      getMoveInCheckListPDFInfo();
    }
  }, [tenantId]);

  const onSubmitMoveInCheckListForm = async () => {
    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
    const tenant_id = tenantId;

    let postData = signatureCommentsData;

    const isManagerSigned = !!postData?.manager_sign;

    const isTenant1Required = !!moveInCheckListInfo?.tenant1_name;
    const isTenant2Required = !!moveInCheckListInfo?.tenant2_name;
    const isTenant3Required = !!moveInCheckListInfo?.tenant3_name;

    const isTenant1Signed = !isTenant1Required || !!postData?.tenant1_sign;
    const isTenant2Signed = !isTenant2Required || !!postData?.tenant2_sign;
    const isTenant3Signed = !isTenant3Required || !!postData?.tenant3_sign;

    const allSigned = isManagerSigned && isTenant1Signed && isTenant2Signed && isTenant3Signed;

    if (!allSigned) {
      toast.error("Signatures missing. Kindly ensure all tenants and the property manager have signed before submitting.");
      return;
    }

    setLoading(true);
    return axios.post(process.env.REACT_APP_PAYMENT_API_URL + `v1/submit-move-in-report/${tenant_id}`, postData, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    }).then((response) => {
      setLoading(false);
      toast.success("Move-In Checklist submitted successfully!");
      onSubmitted && onSubmitted();
      setTimeout(() => setMoveInChecklistOpen(false), 500);
    }).catch((error) => {
      if (typeof error.response !== "undefined")
        toast.error(error.response.data.message);
      setLoading(false);
    });
  }

  const onSubmitArrivalForm = async (formData, sectionName, images, imageSectionName) => {
    setLoading(true);
    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
    const tenant_id = tenantId;

    let postData = {};
    postData[sectionName] = formData;
    if (images.length) {
      postData[imageSectionName] = images;
    }

    return axios.post(process.env.REACT_APP_PAYMENT_API_URL + `v1/move-in-report/${tenant_id}`, postData, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    }).then((response) => {
      setLoading(false);
      toast.success("Your information has been saved successfully.");
    }).catch((error) => {
      if (typeof error.response !== "undefined")
        toast.error(error.response.data.message);
      setLoading(false);
    });
  }

  const getMoveInCheckListInfo = async () => {
    setLoading(true);
    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
    const tenant_id = tenantId;

    return axios.get(process.env.REACT_APP_PAYMENT_API_URL + `v1/move-in-report/${tenant_id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    }).then((response) => {
      setLoading(false);
      setMoveInCheckListInfo(response.data.data);
    }).catch((error) => {
      if (typeof error.response !== "undefined")
        toast.error(error.response.data.message);
      setLoading(false);
    });
  };

  const onSubmitSignatureCommentsData = (key, value) => {
    setSignatureCommentsData((previous) => ({ ...previous, [key]: value }));
  };

  const getMoveInCheckListPDFInfo = async () => {
    setLoading(true);
    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
    const tenant_id = tenantId;

    return axios.get(process.env.REACT_APP_PAYMENT_API_URL + `v1/report-file-content/${tenant_id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    }).then((response) => {
      setLoading(false);
      setMoveInChecklistPDFContent(response.data.data);
    }).catch((error) => {
      if (typeof error.response !== "undefined")
        toast.error(error.response.data.message);
      setLoading(false);
    });
  }

  return (<>
    {loading && <Loader />}
    <div className={moveInChecklistOpen === true ? `${styles.CheckListFormSec} ${styles.Open}` : `${styles.CheckListFormSec}`
    }>
      <div className={`${styles.PanelUnder}`}>
        <div className={`${styles.PanelCloasesec}`}>
          <button onClick={(e) => setMoveInChecklistOpen(false)}>
            <X />
          </button>
        </div>
        {!isFormSubmitted && (<div>
          <FormHeader moveInCheckListInfo={moveInCheckListInfo} />
          <div className={`${styles.FormMainSec}`}>
            <div className="FormAccording Theme">
              <ArrivalForm
                onSubmitArrivalForm={onSubmitArrivalForm}
                tenantId={tenantId}
                setLoading={setLoading}
                moveInCheckListInfo={moveInCheckListInfo}
              />
              <FormComments
                moveInCheckListInfo={moveInCheckListInfo}
                onSubmitSignatureCommentsData={onSubmitSignatureCommentsData}
              />
              <FormFooter
                moveInCheckListInfo={moveInCheckListInfo}
                onSubmitSignatureCommentsData={onSubmitSignatureCommentsData}
                setLoading={setLoading}
              />
              <div className={`${styles.ButtonAction}`}>
                <Button className={`${styles.CancelPopupBU}`} onClick={(e) => setMoveInChecklistOpen(false)}>Cancel</Button>
                <Button className={`${styles.SubmitPopupBU}`} onClick={onSubmitMoveInCheckListForm}>Submit</Button>
              </div>
            </div>
          </div>
        </div>)}
        {isFormSubmitted === 1 && (<div>
          <MoveInChecklistPDF moveInChecklistPDFContent={moveInChecklistPDFContent} />
        </div>)}
      </div>
    </div>
  </>);
};

export default MoveInChecklist;